export default __webpack_public_path__ + "static/media/verandas.561d9982.webp";